export default {
  receivablesManage: {
    collapseTitle: {
      unReceivablesTitle: '待拆分收款信息',
      baseTitle: '基本信息',
      receivablesTitle: '收款信息',
      receivablesClaimTitle: '收款认领信息',
      orderTitle: '收款单信息',
      uploadFileTitle: '附件上传',
    },
    tabTitle: {
      firstClaimsTitle: '一次认领',
      secondClaimsTitle: '二次认领',
      accountingVoucherTitle: '财务凭证',
    },
    placeholder: {
      auto: '自动生成',
      receivedTypePlaceholder: '请选择收款类别',
      claimDepartmentNoPlaceholder: '请选择部门',
      customerNamePlaceholder: '请选择客户',
      claimPartnerNamePlaceholder: '请选择供应商',
      originProformaInvoiceAmountPlaceholder: '请输入形式发票金额',
      originReceiveMoneyAmountPlaceholder: '请输入收款金额',
      salesOrderNoPlaceholder: '请选择销售管理号',
      purchaseOrderNoPlaceholder: '请选择采购管理号',
      paymentNumPlaceholder: '请选择付款单',
      lineNumberPlaceholder: '请选择行号',
      refundAmountPlaceholder: '请输入退款金额',
      exchangeRatePlaceholder: '请输入汇率',
      receivedDetailTypePlaceholder: '请选择收款细类',
    },
    basicInfo: {
      docNo: '收款单号',
      registerNo: '收款登记号',
      registerCompanyCode: '公司',
      registerDate: '收款日期',
      registerCreatePersonNo: '制单人',
      receiveMethod: '收款方式',
      receiveResource: '来源',
      billCode: '票据号',
      clCode: '信用证号',
      clDetailId: '信用证行号',
      receiveBankNo: '收款银行',
      receiveBankAccount: '收款银行账号',
      receiveStatus: '收款状态',
      preclaimDepartmentName: '预认领部门',
      marginPayAccount: '保证金付款银行账号',
    },
    receivablesInfo: {
      payerCode: '付款单位',
      payBankName: '付款银行',
      payBankAccount: '付款银行账号',
      bankFlowNo: '银行流水号',
      originReceiveMoneyAmount: '收款金额',
      localReceiveMoneyAmount: '收款金额（本币）',
      originProformaInvoiceAmount: '形式发票金额',
      localProformaInvoiceAmount: '形式发票金额（本币）',
      originDomesticBankDeductFee: '国内银行扣费',
      localDomesticBankDeductFee: '国内银行扣费（本币）',
      originForeignBankDeductFee: '国外银行扣费',
      localForeignBankDeductFee: '国外银行扣费（本币）',
      receiveInfoCurrencyCode: '币种',
      exchangeRate: '汇率',
      exchangeType: '汇率类型',
      summary: '摘要',
      isAnotherPay: '是否代付',
      anotherPayTime: '代付时间',
      financeAuditStatus: '财务审核状态',
    },
    orderInfo: {
      docNo: '收款单号',
      receiveStatus: '收款状态',
      postTime: '过账日期',
    },
    receivablesClaimInfo: {
      seq: '序号',
      customerNo: '客户',
      claimPartnerNo: '供应商',
      receivedType: '收款类别',
      claimDepartmentNo: '部门',
      secClaimDepartmentNo: '部门编码',
      claimDepartmentName: '部门描述',
      originProformaInvoiceAmount: '形式发票金额',
      localProformaInvoiceAmount: '形式发票金额（本币）',
      originReceiveMoneyAmount: '收款金额',
      localReceiveMoneyAmount: '收款金额（本币）',
      originDomesticBankDeductFee: '国内银行扣费',
      localDomesticBankDeductFee: '国内银行扣费（本币）',
      originForeignBankDeductFee: '国外银行扣费',
      localForeignBankDeductFee: '国外银行扣费（本币）',
      salesOrderNo: '销售合同号',
      ladingNo: '提单号',
      purchaseOrderNo: '采购合同号',
      settleBatchNo: '结算批次',
      contractNo: '业务订单',
      hasClaim: '已认领金额',
      noClaim: '未认领金额',
      receivedDetailType: '收款细类',
    },
    paymentInfo: {
      seq: '序号',
      paymentNum: '付款单',
      lineNumber: '行号',
      paymentAmount: '付款单金额',
      refundAmount: '退款金额',
    },
    button: {
      add: '新增',
      delete: '删除',
    },
    message: {
      baseDataInComplete: '请先完成表单必填信息！',
      onlyOneSelectData: '请选择一条数据进行操作',
      noFirstClaim: '该条记录一次认领还没保存，请先保存！',
      noData: '您还未选择任何数据！',
      noSupplierRefund: '只能对收款类别为供应商退款-非货款进行操作！',
      noSupplierRefundSave: '收款类别或者部门已改变，请先保存！',
      deleteSuccess: '删除成功！',
      cancelled: '已取消！',
      ledgerInfo: '请先配置公司账套',
      rateInfo: '缺少对应汇率，请维护',
      calcInfo: '已认领金额不能超过总金额，请重新输入金额！',
      noMakeCollections: '该条状态不是已认领状态，不能生成收款单！',
      noSalesOrder: '请先选择销售管理号！',
      noPurchaseOrder: '请先选择采购管理号！',
      checkUnClaimAmount: '该收款类别和部门下没有未认领信息，请重新选择！',
      noL: '只有粮化部认领到提单！',
      originProformaInvoiceAmountValid: '国内扣费/国外银行扣费+收款金额必需等于形式发票金额',
      amountValidByBillAmount: '收款金额必需等于所选票据票据金额总额！',
      amountValidByBillDiscountAmount: '收款金额必需等于所选票据贴现所得金额总额！',
      billAmountEmpty: '所选票据票据金额总额为0，请先维护所选票据！',
      billDiscountAmountEmpty: '所选票据贴现所得金额总额为0，请先维护所选票据！',
      billStatusNotDiscount: '所选票据状态存在未贴现数据，请检查所选票据！',
      billStatusNotCollection: '所选票据状态存在未托收数据，请检查所选票据！',
      billCustomerNotSame: '所选票据客户不一致，请检查！',
      customerNotSame: '所选付款单位必需与票据客户一致，请检查！',
      save: '是否确定继续认领？',
      amountNoZero: '收款金额不能为0!',
      onlyGoodsAmount: '收款类别为货款才可进行半自动二次认领!',
    },
  },
};
